import { Link } from "react-router";

// Dev/QA index for the dashboard's plan × sub-state matrix. Mirrors the
// /preview/match-detail pattern. Each link drives the dashboard via the
// `?tools=` / `?state=` / `?welcome=` overrides resolved in _plan.ts, so every
// state is reachable deterministically (Playwright + manual review) without a
// backend. Not part of the production nav.

type PlanOption = { key: string; label: string; tools: string };
type SubState = { key: string; label: string; query: string };

const PLANS: PlanOption[] = [
  { key: "both", label: "Screening + Monitoring", tools: "screening,monitoring" },
  { key: "screening", label: "Screening only", tools: "screening" },
  { key: "monitoring", label: "Monitoring only", tools: "monitoring" },
];

const SUB_STATES: SubState[] = [
  { key: "populated", label: "Populated", query: "" },
  { key: "empty", label: "Empty", query: "&state=empty" },
  { key: "loading", label: "Loading", query: "&state=loading" },
  { key: "welcome", label: "First-time (welcome popup)", query: "&welcome=1" },
];

export default function DashboardStatesPage() {
  return (
    <div className="min-h-screen bg-grey-25 p-8">
      <div className="mx-auto flex max-w-3xl flex-col gap-4">
        <header className="flex flex-col gap-1">
          <h1 className="text-h3 text-black">Dashboard states</h1>
          <p className="text-small text-grey-600">
            Preview every plan × sub-state. Drives the live dashboard via the dev `?tools=`
            override.
          </p>
        </header>

        {PLANS.map((plan) => (
          <section key={plan.key} className="card flex flex-col gap-3">
            <h2 className="text-body font-semibold text-black">{plan.label}</h2>
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              {SUB_STATES.map((sub) => (
                <Link
                  key={sub.key}
                  to={`/dashboard?tools=${plan.tools}${sub.query}`}
                  className="flex items-center justify-between gap-2 rounded-[4px] border border-grey-200 bg-white px-3 py-2 text-small font-medium text-grey-900 shadow-flat transition-colors hover:border-green-400 hover:bg-green-100 hover:text-green-700"
                >
                  {sub.label}
                </Link>
              ))}
            </div>
          </section>
        ))}

        <section className="card flex flex-col gap-3">
          <h2 className="text-body font-semibold text-black">
            Screening match detail (from dashboard)
          </h2>
          <Link
            to="/screening-portal?q=Vladimir%20Putin&runAt=2026-05-13T23:41:00"
            className="flex w-fit items-center justify-between gap-2 rounded-[4px] border border-grey-200 bg-white px-3 py-2 text-small font-medium text-grey-900 shadow-flat transition-colors hover:border-green-400 hover:bg-green-100 hover:text-green-700"
          >
            Vladimir Putin — Dashboard / match results
          </Link>
        </section>
      </div>
    </div>
  );
}
